import { useRef } from "react";
import Chart from "react-apexcharts";

type PieChartProps = {
  options: any;
  width?: number | string;
  height?: number | string;
};

export default function PieChart(props: PieChartProps) {
  const { options, width = "100%", height = 300 } = props;
  return (
    <div className="donut font-readex">
      {!!options && (
        <Chart
          options={options.options}
          series={options.series}
          width={width}
          height={height}
          type="donut"
        />
      )}
    </div>
  );
}

// Data Exmaple
//   const done = "#34D399";
//   const canceled = "#F87171";
//   const scheduled = "#9CA3AF";
//   const legendposition: "bottom" = "bottom";
//   const dir = "ltr" === i18next.dir();
//   return {
//     options: {
//       dataLabels: {
//         enabled: false,
//       },
//       legend: {
//         show: true,
//         position: legendposition,
//         fontFamily: "Readex Pro",
//         markers: {
//           width: 15,
//           height: 15,
//           offsetX: dir ? -3 : 3,
//         },
//       },
//       colors: [scheduled, done, canceled],
//       labels: ["ملغاة", "مقطوعة", "مجدولة"],
//     },
//     series: [44, 55, 41],
//   };
//
